import styled from 'styled-components';
import { Col, Container, Row } from 'components/atoms/Grid';
import Colors from 'components/tokens/Colors';
import Text from 'components/atoms/Text';
import { sbEditable } from '@storyblok/storyblok-editable';

export default function EducationBanner(props) {
    return (
        <MainContent {...sbEditable(props)}>
            <Container px="1.5 1">
                <Row alignItems="center" pt="5" pb="5">
                    <Col mb="3 0" size="12 5" pl="1 4">
                        <Text size="32 40" lineHeight="30 32" title color={Colors.white}>
                            {props?.title}
                        </Text>
                    </Col>
                    <Col size="12 7" pr="1 4" text="left right">
                        <Text size="16" lineHeight="22 24" highlight color={Colors.white}>
                            {props?.description}
                        </Text>
                    </Col>
                </Row>
            </Container>
        </MainContent>
    );
}

const MainContent = styled.div`
    width: 100%;
    background-color: ${Colors.black};
`;
